module.exports = {"150724100":"巴彦托海镇","150724110":"大雁镇","150724111":"伊敏河镇","150724112":"红花尔基镇","150724210":"巴彦嵯岗苏木","150724211":"锡尼河西苏木","150724212":"锡尼河东苏木","150724213":"巴彦塔拉达斡尔民族乡","150724214":"伊敏苏木","150724215":"辉苏木","150724400":"巴彦托海经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150724.json
// module id = 538
// module chunks = 0